// extracted by mini-css-extract-plugin
module.exports = {"flashNewsTit":"index_flashNewsTit__Mm0sq","tabs":"index_tabs__F7NP7","flashNewsBox":"index_flashNewsBox__qq0bY"};